import React from "react";
import {Box} from "@mui/material";
import './PurchasedBadge.css'
import {useTranslation} from "react-i18next";

interface PurchasedBadgeProps {
    current: number;
    total: number;
}

const PurchasedBadge: React.FC<PurchasedBadgeProps> = ({ current, total }) => {
    const { t, i18n } = useTranslation();
    return (
        <Box
            className={"purchased-badge-box"}
        >
            {current} / {total} {t('productPurchased').toUpperCase()}
        </Box>
    );
};

export default PurchasedBadge;
